// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline[data-v-529ddaa2] {\n  text-align: center;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n.btn[data-v-529ddaa2] {\n  margin: 10px;\n}\n.timelines[data-v-529ddaa2] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
